import React from "react";
import ProductDetailImgComp from "./ProductDetailImgComp";
import ProductDetailExplanationComp from "./ProductDetailExplanationComp";
function ProductDetailComp() {
  return (
    <div>
      <ProductDetailImgComp />
      <ProductDetailExplanationComp />
    </div>
  );
}

export default ProductDetailComp;
